import ApiService from '../api.service';

const Checkouts = {
  create: (params) => ApiService.post('users/me/checkouts', params),
};

export default Checkouts;
